import { Button } from "antd";
import { shortenValue, useGlobalMerchant } from "utils/helper";
import { RightArrowIcon } from "svgIcon";

const ECEShippingComponent = ({
    itemList,
    grandTotal,
    onCheckout,
    onBtnLoader,
}: any) => {
    const { globalMerchantCurrency } = useGlobalMerchant();
    return (
        <div className="billingSummary">
            <div className="bSumHeader">
                <p className="eMdText textUpper">Order Summary</p>
            </div>
            <div className="bSumBody">
                {itemList.map((items: any) => (
                    <div key={items.product.product_id} className='dFlex alignCenter bSumProductList justifyBetween'>
                        <span className="eNmText">
                            {items.product.product_name}
                        </span>
                        <span className="eMdText">
                            {shortenValue(items.qty * items.product.price)} {globalMerchantCurrency}
                        </span>
                    </div>
                ))}
                <div className='dFlex justifyBetween bSumTotal alignCenter'>
                    <p className="eMdText fontNormal">Total Amount</p>
                    <p className="eLgText">{shortenValue(grandTotal)} {globalMerchantCurrency}</p>
                </div>
                <p className="eXSmText">
                    When placing an order, we ask for your email and phone number (both
                    optional) as well as your address (required for delivery). This
                    information is used solely to process your order.
                </p>
            </div>
            <div className="bSumFooter">
                <Button
                    className="eBtn"
                    type="primary"
                    onClick={() => onCheckout()}
                    disabled={grandTotal === 0}
                >
                    {onBtnLoader ? "Loading..." : "Proceed To Checkout"}<span><RightArrowIcon /></span>
                </Button>
            </div>
        </div>
    );
};

export default ECEShippingComponent;
